import { Button, Flex } from 'front-commons/ds';
import { Typography, Icon } from 'hype-ds';
import { HeaderProps } from '../interfaces';
import { useMemo } from 'react';
import useDrawer from 'stores/drawer';

export default function Header({ suggestionQuantity }: HeaderProps) {
	const { handleCloseDrawer } = useDrawer();

	const { promotion, founded, the, product } = useMemo(() => {
		const isSingle = suggestionQuantity === 1;

		return {
			the: isSingle ? 'o' : 'os',
			product: isSingle ? 'produto' : 'produtos',
			founded: isSingle ? 'encontrada' : 'encontradas',
			promotion: isSingle ? 'promoção' : 'promoções',
		};
	}, []);

	const handleCloseDrawerClick = () => {
		handleCloseDrawer('promotion-suggestion');
	};

	return (
		<Flex
			gap="0"
			margin="16px"
			border="1px solid"
			padding="0 0 8px"
			direction="column"
			borderWidth="0 0 1px"
			borderColor="--border-primary"
		>
			<Flex justifyContent="space-between" alignItems="center">
				<Typography.Heading.XXS>
					{promotion.toPascalCase()} com {the} {product}
				</Typography.Heading.XXS>

				<Button variant="none" onClick={handleCloseDrawerClick}>
					<Icon name="close" size="24px" color="--text-link" />
				</Button>
			</Flex>

			<Typography.Paragraph.XS color="--text-secondary">
				{suggestionQuantity} {promotion} {founded}
			</Typography.Paragraph.XS>
		</Flex>
	);
}
